"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var addTablePy_1 = require("../logic/addTablePy");
var graphicsAdapters_1 = require("../logic/graphicsAdapters");
var grid_logic_1 = require("../logic/grid-logic");
var accounting = require('accounting');
angular.module('smartorg.r6.acts.addTables').directive('addTableCollection', ["$timeout", 'uiGridGroupingConstants', function ($timeout, uiGridGroupingConstants) {
        var template = require('../../template/addTableCollection.html');
        return {
            restrict: 'E',
            template: template,
            scope: {
                menu: '=',
                smartorgApi: '='
            },
            link: function (scope) {
                scope.showAlert = function (type, title, message) {
                    scope.$emit('workbench:alert', { type: type, title: title, message: message });
                };
                function triggerResize() {
                    $(window).trigger('resize');
                }
                scope.isNaN = function (input) {
                    return isNaN(input);
                };
                scope.$on('workbench:toggle-collapse:right', function () {
                    $timeout(triggerResize);
                });
                scope.$on('workbench:toggle-collapse:left', function () {
                    $timeout(triggerResize);
                });
                scope.$on('command:ADD_TABLES', function (event, args) {
                    scope.gridOptions = null;
                    scope.shadowGridOptions = null;
                    $timeout(function () {
                        initAddTables(args);
                    });
                });
                function initAddTables(args) {
                    return __awaiter(this, void 0, void 0, function () {
                        function getRowChartDatas(tableData) {
                            var a = {};
                            var result = [];
                            for (var i = 0; i < tableData.length; i++) {
                                a = tableData[i].getRowChartData();
                                result.push(a);
                            }
                            return result;
                        }
                        function getColChartDatas(tableData) {
                            var a = {};
                            var result = [];
                            for (var i = 0; i < tableData.length; i++) {
                                a = tableData[i].getColChartData();
                                result.push(a);
                            }
                            return result;
                        }
                        var tableData, exportConfig, _a, settings, chartIdPresent, i, i, portfolioName, portfolioConfig;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    scope.actionMenuItem = args.actionMenuItem;
                                    tableData = args.config.data.data;
                                    scope.inputData = tableData.inputData;
                                    scope.shadowData = tableData.shadowData && tableData.shadowData.length > 0 ?
                                        tableData.shadowData : null;
                                    scope.config = tableData;
                                    scope.nodeID = args.nodeID;
                                    scope.treeName = args.treeName;
                                    scope.chartSettings = args.config.data.chartSettings;
                                    exportConfig = null;
                                    if ('export' in tableData) {
                                        exportConfig = tableData["export"];
                                    }
                                    scope.breadCrumb = args.node.getBreadcrumb();
                                    scope.inputData = scope.inputData.map(function (obj) {
                                        obj.path = scope.breadCrumb;
                                        return obj;
                                    });
                                    if (scope.shadowData) {
                                        scope.shadowBreadCrumb = args.compareToNode.getBreadcrumb();
                                        scope.shadowData = scope.shadowData.map(function (obj) {
                                            obj.path = scope.shadowBreadCrumb;
                                            return obj;
                                        });
                                    }
                                    _a = scope;
                                    return [4 /*yield*/, scope.smartorgApi.getUserPrivilege(scope.nodeID)];
                                case 1:
                                    _a.userPrivilege = _b.sent();
                                    scope.addTableProvider = new addTablePy_1.AddTablesProvider(scope.inputData, scope.config, scope.shadowData, scope.actionMenuItem, exportConfig);
                                    if (tableData.displayRules) {
                                        scope.ignoreColInCharts = scope.addTableProvider.handleIgnoreColInCharts_displayRule();
                                    }
                                    scope.addTables = scope.addTableProvider.tables;
                                    //masterTables has all the data, but no colors yet
                                    scope.masterTables = scope.addTableProvider.masterTables;
                                    scope.legends = scope.addTableProvider.legends;
                                    if (scope.addTableProvider.shadowTables) {
                                        scope.shadowAddTables = scope.addTableProvider.shadowTables;
                                        scope.hasShadow = true;
                                        scope.shadowDisplay = 'TABLE';
                                    }
                                    else {
                                        scope.hasShadow = false;
                                        scope.shadowAddTables = undefined;
                                    }
                                    scope.title = scope.addTableProvider.title;
                                    scope.pnl = scope.addTableProvider.pnl;
                                    scope.chartType = scope.pnl ? "line" : "bar";
                                    scope.display = 'TABLE';
                                    scope.menu = getTableMenu();
                                    settings = args.config.data.settings;
                                    chartIdPresent = false;
                                    for (i = 0; i < settings.setChartAsDefault.addTable.row.length; i++) {
                                        if (scope.actionMenuItem === settings.setChartAsDefault.addTable.row[i]['chartId']) {
                                            scope.chartType = settings.setChartAsDefault.addTable.row[i]['chartType'];
                                            scope.chartByRow();
                                            scope.orientation = settings.setChartAsDefault.addTable.row[i]['orientation'];
                                            chartIdPresent = true;
                                        }
                                    }
                                    if (!chartIdPresent) {
                                        for (i = 0; i < settings.setChartAsDefault.addTable.col.length; i++) {
                                            if (scope.actionMenuItem === settings.setChartAsDefault.addTable.col[i]['chartId']) {
                                                scope.chartType = settings.setChartAsDefault.addTable.col[i]['chartType'];
                                                scope.chartByCol();
                                                scope.orientation = settings.setChartAsDefault.addTable.col[i]['orientation'];
                                            }
                                        }
                                    }
                                    scope.numDecimals = 2;
                                    portfolioName = args.treeName;
                                    if (localStorage.getItem('PortfolioConfig') &&
                                        portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                                        portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
                                        scope.numDecimals = portfolioConfig['table']['decimals'];
                                        scope.timestampMode = portfolioConfig['timestamp'] ? portfolioConfig['timestamp']['timestampMode'] :
                                            (settings ? settings.timestampMode : 'lastRecalc');
                                        scope.chartSettings = portfolioConfig['chart'];
                                        scope.chartSettings.timestampMode = scope.timestampMode;
                                    }
                                    else if (args.config.data.settings && args.config.data.chartSettings) {
                                        scope.numDecimals = args.config.data.settings.decimals;
                                        scope.timestampMode = args.config.data.settings.timestampMode;
                                        scope.chartSettings = args.config.data.chartSettings;
                                    }
                                    if (scope.numDecimals == "Default") {
                                        if (scope.addTableProvider['defaultPrecision']) {
                                            scope.numDecimals = scope.addTableProvider['defaultPrecision'];
                                        }
                                    }
                                    scope.timestamp = args.node.lastRecalc;
                                    scope.fontSize = "MediumFont";
                                    scope.rowChartDatas = getRowChartDatas(scope.addTables);
                                    scope.colChartDatas = getColChartDatas(scope.addTables);
                                    if (scope.hasShadow) {
                                        scope.shadowRowChartDatas = getRowChartDatas(scope.shadowAddTables);
                                        scope.shadowColChartDatas = getColChartDatas(scope.shadowAddTables);
                                    }
                                    if (args.config.data.specialRules) {
                                        scope.specialRulesColHeader = args.config.data.specialRules.map(function (arr, index) {
                                            return arr.ColHeader;
                                        });
                                    }
                                    if (scope.config.colorByList && scope.config.colorByList.length > 0) {
                                        scope.gridOptions = updateMultipleTable(scope.masterTables, {
                                            numDecimals: scope.numDecimals,
                                            enableSorting: !scope.pnl,
                                            timestampMode: scope.timestampMode,
                                            timestamp: scope.timestamp
                                        }, scope.config.colorByList, scope.config.config.colors, null, tableData.displayRules);
                                    }
                                    else {
                                        scope.gridOptions = updateMultipleTable(scope.masterTables, {
                                            numDecimals: scope.numDecimals,
                                            enableSorting: !scope.pnl,
                                            timestampMode: scope.timestampMode,
                                            timestamp: scope.timestamp
                                        }, null, null, null, tableData.displayRules);
                                    }
                                    if (scope.hasShadow) {
                                        scope.shadowGridOptions = updateMultipleTable(scope.shadowData, {
                                            numDecimals: scope.numDecimals,
                                            enableSorting: !scope.pnl,
                                            timestampMode: scope.timestampMode,
                                            timestamp: scope.timestamp
                                        }, null, null, '#f9a65a', tableData.displayRules);
                                    }
                                    else {
                                        scope.shadowGridOptions = null;
                                    }
                                    $timeout();
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
                accounting.settings = {
                    currency: {
                        symbol: "",
                        format: "%s%v",
                        decimal: ".",
                        thousand: ",",
                        precision: 0 // decimal places
                    },
                    number: {
                        precision: 0,
                        thousand: ",",
                        decimal: "."
                    }
                };
                var downloadCSV = function (csv, type) {
                    var namePrefix = "AddTables";
                    if (scope.addTables && scope.addTables.length == 1) {
                        namePrefix = scope.addTables[0].title;
                    }
                    else {
                        console.error("Add table length error, use default.");
                    }
                    if (type) {
                        namePrefix += "(" + type + ")";
                    }
                    namePrefix += "_";
                    Common.downloadCSV(csv, namePrefix);
                };
                scope.chartByRow = function () {
                    scope.display = 'ROW';
                    scope.shadowDisplay = 'ROW';
                    scope.chartType = scope.pnl ? 'line' : 'bar';
                    scope.orientation = 'horizontal';
                    scope.menu = getRowChartMenu();
                };
                scope.chartByCol = function () {
                    scope.display = 'COL';
                    scope.shadowDisplay = 'COL';
                    scope.chartType = 'bar';
                    scope.orientation = 'horizontal';
                    scope.menu = getColChartMenu();
                };
                scope.showTables = function () {
                    scope.display = 'TABLE';
                    scope.shadowDisplay = 'TABLE';
                    scope.menu = getTableMenu();
                };
                scope.changeFontSize = function (fontSize) {
                    scope.fontSize = fontSize;
                };
                scope.exportSummary = function () {
                    var csv = scope.addTableProvider.exportCSV(false);
                    downloadCSV(csv, "Summary");
                };
                scope.exportExpanded = function () {
                    var csv = scope.addTableProvider.exportCSV(true);
                    downloadCSV(csv, "Expanded");
                };
                scope.exportDetailsOnly = function () {
                    var csv = scope.addTableProvider.exportCSV(true, "skipSummaryLines");
                    downloadCSV(csv, "Details Only");
                };
                scope.exportSummaryEuropean = function () {
                    var csv = scope.addTableProvider.exportEuCSV(false);
                    downloadCSV(csv, "Summary EU");
                };
                scope.exportExpandedEuropean = function () {
                    var csv = scope.addTableProvider.exportEuCSV(true);
                    downloadCSV(csv, "Expanded EU");
                };
                scope.exportDetailsOnlyEuropean = function () {
                    var csv = scope.addTableProvider.exportEuCSV(true, "skipSummaryLines");
                    downloadCSV(csv, "Details Only EU");
                };
                scope.exportCharts = function () {
                    var exporter = new smartorg.r6.lib.ChartExporter("chart", "svg-canvas");
                    exporter.exportChart(scope.addTables[0].title, true);
                };
                function updateMultipleTable(tableData, options, colorByList, colors, shadowColor, displayRults) {
                    if (shadowColor === void 0) { shadowColor = null; }
                    if (displayRults === void 0) { displayRults = null; }
                    return grid_logic_1["default"].makeMultipleTable(tableData, options, colorByList, colors, shadowColor, displayRults);
                }
                scope.format = function (col, index) {
                    if (!scope.displayRules[index].format) {
                        return col;
                    }
                    if (isNaN(col)) {
                        return col;
                    }
                    if (scope.displayRules[index]['high'] && parseFloat(col) == parseFloat(scope.displayRules[index]['high'])) {
                        return scope.displayRules[index]['veryLargeText'] || 'Very Large';
                    }
                    var formattedNumber = "";
                    if (scope.pnl === true) {
                        formattedNumber = accounting.formatMoney(col);
                    }
                    else {
                        formattedNumber = accounting.formatNumber(col);
                    }
                    return formattedNumber;
                };
                scope.leftShiftYear = function () {
                    scope.addTableObject.leftShiftYear();
                    scope.minHeaderIndex = scope.addTableObject.minHeaderIndex;
                };
                scope.rightShiftYear = function () {
                    scope.addTableObject.rightShiftYear();
                    scope.minHeaderIndex = scope.addTableObject.minHeaderIndex;
                };
                scope.triggerLine = function (indexOfRow) {
                    scope.addTableObject.triggerLineExpand(indexOfRow, scope.shadow, scope.groupBy, scope.groupbyColor, scope.colorBy);
                };
                function getTableMenu() {
                    var tableMenu = [
                        {
                            'name': 'Display',
                            'items': [{
                                    'name': 'Chart by Row',
                                    'callback': function () {
                                        scope.chartByRow();
                                    }
                                }, {
                                    'name': 'Chart by Column',
                                    'callback': function () {
                                        scope.chartByCol();
                                    }
                                }]
                        },
                        {
                            'name': 'Export',
                            'items': [{
                                    'name': 'Summary',
                                    'callback': function () {
                                        scope.exportSummary();
                                    }
                                }, {
                                    'name': 'Expanded',
                                    'callback': function () {
                                        scope.exportExpanded();
                                    }
                                }, {
                                    'name': 'Details Only',
                                    'callback': function () {
                                        scope.exportDetailsOnly();
                                    }
                                }, {
                                    'name': 'Summary EU',
                                    'callback': function () {
                                        scope.exportSummaryEuropean();
                                    }
                                }, {
                                    'name': 'Expanded EU',
                                    'callback': function () {
                                        scope.exportExpandedEuropean();
                                    }
                                }, {
                                    'name': 'Details Only EU',
                                    'callback': function () {
                                        scope.exportDetailsOnlyEuropean();
                                    }
                                }]
                        }
                    ];
                    if (scope.userPrivilege === 3) {
                        tableMenu[0]['items'].push({
                            'name': 'Set as Default',
                            'callback': function () {
                                setChartAsDefault("table", null);
                            }
                        });
                    }
                    return tableMenu;
                }
                function getRowChartMenu() {
                    var rowChartMenu = [
                        {
                            'name': 'Display',
                            'items': [{
                                    'name': 'Table',
                                    'callback': function () {
                                        scope.showTables();
                                    }
                                }, {
                                    'name': 'Chart by Column',
                                    'callback': function () {
                                        scope.chartByCol();
                                    }
                                }]
                        }, {
                            'name': 'Export',
                            'items': [{
                                    'name': 'Chart',
                                    'callback': function () {
                                        scope.exportCharts();
                                    }
                                }]
                        }
                    ];
                    if (scope.userPrivilege === 3) {
                        rowChartMenu[0]['items'].push({
                            'name': 'Set as Default',
                            'callback': function () {
                                setChartAsDefault("row", scope.chartType);
                            }
                        });
                    }
                    return rowChartMenu;
                }
                function getColChartMenu() {
                    var colChartMenu = [
                        {
                            'name': 'Display',
                            'items': [{
                                    'name': 'Table',
                                    'callback': function () {
                                        scope.showTables();
                                    }
                                }, {
                                    'name': 'Chart by Row',
                                    'callback': function () {
                                        scope.chartByRow();
                                    }
                                }]
                        }, {
                            'name': 'Export',
                            'items': [{
                                    'name': 'Chart',
                                    'callback': function () {
                                        scope.exportCharts();
                                    }
                                }]
                        }
                    ];
                    if (scope.userPrivilege === 3) {
                        colChartMenu[0]['items'].push({
                            'name': 'Set as Default',
                            'callback': function () {
                                setChartAsDefault("col", "bar");
                            }
                        });
                    }
                    return colChartMenu;
                }
                function setChartAsDefault(chartBy, chartType) {
                    scope.smartorgApi.setChartAsDefault(scope.treeName, scope.actionMenuItem, "addTable", chartBy, chartType, scope.orientation, null).then(function (res) {
                        console.log(res.message);
                        scope.showAlert('success', 'Saved!', res.message);
                    })["catch"](function (err) {
                        scope.showAlert('danger', 'Error!', err.message);
                    });
                }
                scope.$on('addTables:chartType', function (event, args) {
                    scope.chartType = args.chartType;
                });
                scope.$on('addTables:orientation', function (event, args) {
                    scope.orientation = args.orientation;
                });
            }
        };
    }]).directive('chart', [function () {
        var template = require('../../template/chart.html');
        return {
            restrict: 'A',
            template: template,
            scope: {
                chartBy: '=',
                chartType: '=',
                chartInputData: '=',
                chartName: '=',
                orientation: '=',
                ignoreColInCharts: '=',
                chartSettings: '=',
                chartTimestamp: '='
            },
            link: function (scope) {
                var hashCode = function (input) {
                    var hash = 0, i, char, l;
                    if (input.length == 0)
                        return hash;
                    for (i = 0, l = input.length; i < l; i++) {
                        char = input.charCodeAt(i);
                        hash = ((hash << 5) - hash) + char;
                        hash |= 0; // Convert to 32bit integer
                    }
                    return "hashed" + Math.abs(hash).toString();
                };
                scope.matrixOrientation = "original";
                scope.origType = scope.chartType;
                scope.chartID = hashCode('chart_div_' + scope.origType + "_" + scope.chartName);
                scope.changeColSelected = function (newColName) {
                    scope.colSelected = newColName;
                    scope.drawChart();
                };
                scope.$watch('chartInputData', function () {
                    if (scope.chartInputData !== undefined && scope.chartType !== undefined) {
                        scope.chartMatrix = new addTablePy_1.Matrix(scope.chartInputData.matrixData).trimEmptyCols().trimEmptyRows();
                        if (scope.ignoreColInCharts !== undefined) {
                            if (scope.chartType === "line") {
                                scope.chartMatrix = scope.chartMatrix.withoutRows(scope.ignoreColInCharts);
                            }
                            else if (scope.chartType === "bar") {
                                scope.chartMatrix = scope.chartMatrix.withoutCols(scope.ignoreColInCharts);
                            }
                        }
                        var adapter = new graphicsAdapters_1.HighCharts(scope.chartType, scope.chartName, scope.chartSettings, scope.chartTimestamp);
                        adapter.setup(scope.chartMatrix.data, scope.orientation);
                        if (scope.chartInputData.drillDownData) {
                            adapter.applyDrillDownData(scope.chartInputData.drillDownData);
                        }
                        scope.adapter = adapter;
                        scope.drawChart();
                    }
                });
                scope.arrayOfFalseValues = function (num) {
                    var answer = [];
                    for (var i = 0; i < num; i++) {
                        answer.push(false);
                    }
                    return answer;
                };
                scope.toggleChartType = function () {
                    scope.chartType = scope.chartType === 'bar' ? 'line' : 'bar';
                    var chartType = scope.chartType;
                    scope.$emit('addTables:chartType', { chartType: chartType });
                    scope.drawChart();
                };
                scope.rotate = function () {
                    scope.orientation = scope.orientation === "horizontal" ? 'vertical' : 'horizontal';
                    var orientation = scope.orientation;
                    scope.$emit('addTables:orientation', { orientation: orientation });
                    scope.drawChart();
                };
                scope.transpose = function () {
                    scope.chartMatrix = scope.chartMatrix.transpose();
                    scope.matrixOrientation = scope.matrixOrientation === "original" ? 'transposed' : 'original';
                    scope.chartInputData = scope.chartMatrix.data;
                };
                scope.drawChart = function () {
                    scope.adapter.setType(scope.chartType, scope.orientation);
                    scope.adapter.drawOn(hashCode('chart_div_' + scope.origType + "_" + scope.chartName), scope.chartType);
                };
            }
        };
    }]);
//# sourceMappingURL=controllers.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-tables/app/js/plumbing/controllers.js